<template>
  <main id="authorHome" v-if="isAuthed">
    <Toolbars ref="toolbars"
      :status="config.status"
      :authors="store.authors"
      :arrangers="store.arrangers"
      @emit="emitted"
    />
    <v-list dense class="py-0 transparent" :three-line="$vuetify.breakpoint.xsOnly">
      <v-list-item class="px-0 mx-3" v-if="$vuetify.breakpoint.smAndUp">
        <v-row>
          <v-col :class="[ 'primary text-center blue-grey--text text--darken-3 font-weight-black', { caption: $vuetify.breakpoint.smAndDown } ]">出発日</v-col>
          <v-col :class="[ 'primary text-center blue-grey--text text--darken-3 font-weight-black', { caption: $vuetify.breakpoint.smAndDown } ]">帰国日</v-col>
          <v-col :class="[ 'primary text-center blue-grey--text text--darken-3 font-weight-black', { caption: $vuetify.breakpoint.smAndDown } ]">名前</v-col>
          <v-col :class="[ 'primary text-center blue-grey--text text--darken-3 font-weight-black', { caption: $vuetify.breakpoint.smAndDown } ]">留学先</v-col>
          <v-col :class="[ 'primary text-center blue-grey--text text--darken-3 font-weight-black', { caption: $vuetify.breakpoint.smAndDown } ]">学校</v-col>
          <v-col :class="[ 'primary text-center blue-grey--text text--darken-3 font-weight-black', { caption: $vuetify.breakpoint.smAndDown } ]">担当者</v-col>
        </v-row>
      </v-list-item>
      <v-progress-linear indeterminate :color="isLoading ? 'secondary' : 'transparent'"></v-progress-linear>
      <template v-for="item in getItems">
        <v-list-item :key="item.id" class="px-0 it-hv mx-3" :to="`../client/${item.cid}`" target="_blank">
          <v-row v-if="$vuetify.breakpoint.smAndUp">
            <v-col :class="[ 'text-center text-truncate', { caption: $vuetify.breakpoint.smAndDown}]">{{ item.start }}</v-col>
            <v-col :class="[ 'text-center text-truncate', { caption: $vuetify.breakpoint.smAndDown}]">{{ item.end }}</v-col>
            <v-col :class="[ 'text-center text-truncate', { caption: $vuetify.breakpoint.smAndDown}]">{{ item.client.join(' ') }}</v-col>
            <v-col :class="[ 'text-center text-truncate', { caption: $vuetify.breakpoint.smAndDown}]">{{ item.country }}</v-col>
            <v-col :class="[ 'text-center text-truncate', { caption: $vuetify.breakpoint.smAndDown}]">{{ item.title }}</v-col>
            <v-col :class="[ 'text-center text-truncate', { caption: $vuetify.breakpoint.smAndDown}]">{{ item.author }}</v-col>
          </v-row>
          <v-list-item-content v-else>
            <v-list-item-subtitle class="caption">
              <span class="font-weight-bold">出発日：</span>{{ item.start }}
              <span class="font-weight-bold">帰国日：</span>{{ item.end }}
            </v-list-item-subtitle>
            <v-list-item-title class="body-1">{{ item.client.join(' ') }}</v-list-item-title>
            <v-list-item-subtitle class="caption">
              <span class="font-weight-bold">国：</span>{{ item.country }}
              <span class="font-weight-bold">申込：</span>{{ item.title }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider :key="item.id + '_div'"></v-divider>
      </template>
    </v-list>
  </main>
</template>

<script>
import Toolbars from './toolbars'
export default {
  name: 'authorHome',
  components: {
    Toolbars
  },
  data () {
    return {
      config: {
        status: {
          loading: false,
          authed: false
        }
      },
      meta: {
        authors: []
      },
      store: {
        arranges: [],
        authors: {}
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      this.auth()
      this.getConsultants()
    },
    emitted: function (req) {
      if (
        req &&
        req.action &&
        typeof this[req.action] === 'function'
      ) {
        this[req.action](req.data)
      }
    },
    auth: function () {
      let auths = this.$store.getters['author/get']('authority')
      let permit = this.$route.meta.permit
      if (!auths.includes(permit)) {
        // this.$router.push('/author/clients')
        this.$set(this.config.status, 'authed', true)
      } else {
        this.$set(this.config.status, 'authed', true)
      }
    },
    get: function (fm) {
      if (fm) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(`${this.$url.api}home/get/items`, fm, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$set(this.store, 'arranges', res.data.data.arranges)
              this.$refs.toolbars.count(res.data.data.count)
            }
            this.$set(this.config.status, 'loading', false)
          }).catch(err => {
            console.log(err)
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    getConsultants: function () {
      this.$author.consultants().then(authors => {
        this.$set(this.store, 'authors', [])
        this.$set(this.meta, 'authors', {})
        for (let i = 0; i < authors.length; i++) {
          let it = authors[i]
          this.store.authors.push({
            userid: it.userid,
            name: it.name[0]
          })
          this.meta.authors[it.userid] = it.name[0]
        }
      })
    }
  },
  computed: {
    isAuthed () {
      return this.config.status.authed
    },
    isDevMode () {
      return this.$store.getters['author/get']('dev')
    },
    isLoading () {
      return this.config.status.loading
    },
    getItems () {
      return this.store.arranges.map(it => {
        const { arrange, client } = it
        return {
          id: arrange.id,
          start: arrange.start === '0000-00-00' ? '未定' : this.$moment(arrange.start).format('YY/MM/DD'),
          end: arrange.end === '0000-00-00' ? '未定' : this.$moment(arrange.end).format('YY/MM/DD'),
          client: client.name.split(','),
          cid: client.id,
          country: this.$mango.nations[arrange.country] ? this.$mango.nations[arrange.country] : arrange.country,
          title: arrange.title,
          author: this.meta.authors[client.aid] ? this.meta.authors[client.aid] : client.aid
        }
      })
    }
  }
}
</script>

<style lang="scss">
#authorHome {
  #legacy {
    width: 100%;
    height: 100%;
    iframe {
      display: block;
      width: 100%;
      height: 100%;
      border: none;
    }
  }
}
</style>
